<template>
  <div>
    <component
      v-if="!$route.query.mobile"
      :ref="CFCreditReportFFormMDP.myRefName"
      :is="CFCreditReportFFormMDP.componentName"
      :value="selectModel(creditReportHtmlInput, undefined)"
      @input="
        (newValue) => updateModel(creditReportHtmlInput, newValue, undefined)
      "
      v-bind="CFCreditReportFFormMDP.props"
    />
    <CFCreditReportComp
      v-if="creditReportJson"
      :reportData="creditReportJson"
    />
  </div>
</template>

<script lang="ts">
import * as Data from "@/../src-gen/data";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { component } from "vue/types/umd";
import * as Action from "@/../src-gen/action";

import CFCreditReportComp from "../file/components/CFCreditReportComp.vue";
import DataPreprocessor from "../file/components/data-preprocessor";
import ModelVue from "@/components/ModelVue";
import CreditReportFFormMDP from "./CreditReportFFormMDP";
import FForm from "@/components/form/FForm.vue";
import axios from "axios";
// import { HelixApi } from "@/remote-api-point";


@Component({
  components: {
    FForm,
    CFCreditReportComp: CFCreditReportComp,
  },
})
export default class CreditReport extends ModelVue {
  creditReportHtmlOutput: Data.Partner.CreditReportHtmlOutput =
    new Data.Partner.CreditReportHtmlOutput();
  clientFileId = this.$route.params.clientFileId;

  creditReportHtmlInput: Data.Partner.CreditReportHtmlInput =
    new Data.Partner.CreditReportHtmlInput();

  parsedHtml: any = null;
  get CFCreditReportFFormMDP() {
    return new CreditReportFFormMDP({ parent: this }).getMetaData();
  }
  creditReportJson: any = {};
  mounted() {
    const mobileFromRoute =
      (this.$route.params.mobile as string) ||
      (this.$route.query.mobile as string);

    if (mobileFromRoute) {
      this.creditReportHtmlInput.mobile = mobileFromRoute;

      this.getCreditReportHtml();
    }
  }

  async getCreditReportHtml() {
    const mobile = this.creditReportHtmlInput.mobile;
    this.creditReportHtmlInput.mobile = mobile;
    const response = await axios.get(process.env.VUE_APP_HELIX_URL+
      `credrouteapi/creditdetails/get-f-f-credit-report?mobile=${mobile}`,
    );
    console.log(response?.data?.ffReport, "Data");
    let creditReportJson = response?.data?.ffReport || {};
    if (creditReportJson) {
      creditReportJson =
        await DataPreprocessor.preprocessAccountInfoFromPayload(
          creditReportJson,
        );
      creditReportJson = await DataPreprocessor.preprocessNameFromPayload(
        creditReportJson,
      );
      creditReportJson = await DataPreprocessor.preprocessMobileNumber(
        creditReportJson,
      );
      creditReportJson = await DataPreprocessor.preprocessTotalAccounts(
        creditReportJson,
      );
    }
    this.creditReportJson = creditReportJson;
  }
}
</script>
<style scoped></style>
